import { useState } from "react";
import { FileText, Printer } from "lucide-react";
import { Button } from "@/components/ui/Button";
import type { SolicitacaoPagamentoDto } from "@/services/solicitacaoPagamento";
import {
  generatePaymentRequestPdf,
  printPaymentRequestPdf,
} from "./paymentRequestPdfActions";

interface Props {
  item: SolicitacaoPagamentoDto;
  geradoPor: string;
}

export function PaymentRequestPdfButtons({ item, geradoPor }: Props) {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGenerate = async () => {
    setLoadingPdf(true);
    setError(null);
    try {
      await generatePaymentRequestPdf(item, geradoPor);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erro ao gerar PDF.");
    } finally {
      setLoadingPdf(false);
    }
  };

  const handlePrint = async () => {
    setLoadingPrint(true);
    setError(null);
    try {
      await printPaymentRequestPdf(item, geradoPor);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erro ao imprimir.");
    } finally {
      setLoadingPrint(false);
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        leftIcon={<FileText className="w-4 h-4" />}
        onClick={() => void handleGenerate()}
        loading={loadingPdf}
        disabled={loadingPrint}
      >
        Gerar PDF
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        leftIcon={<Printer className="w-4 h-4" />}
        onClick={() => void handlePrint()}
        loading={loadingPrint}
        disabled={loadingPdf}
      >
        Imprimir
      </Button>
      {error && <span className="w-full text-xs text-red-600">{error}</span>}
    </>
  );
}
